import { isoZ, z } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

export const manualAdjustmentTypeOptions = ['SafetyStock', 'GuideVehicle', 'VehicleAddition'] as const
export const seasonInventoryTypeOptions = ['SeasonStart', 'SeasonEnd'] as const
export const workOrderInventoryTypeOptions = ['WorkOrder'] as const

export const inventoryTypeOptions = [
  ...manualAdjustmentTypeOptions,
  ...seasonInventoryTypeOptions,
  ...workOrderInventoryTypeOptions
] as const
export const inventoryTypes = enumOptionsToObject(inventoryTypeOptions)
export type InventoryType = (typeof inventoryTypeOptions)[number]

const OutfitterInventoryTypeEnum = z.enum(inventoryTypeOptions).setEnumLabels({
  SeasonStart: 'Season Start',
  SeasonEnd: 'Season End',
  WorkOrder: 'Work Order',
  SafetyStock: 'Safety Stock',
  GuideVehicle: 'Guide Vehicle',
  VehicleAddition: 'Vehicle Addition'
})

export const outfitterInventoryModel = z.object({
  id: z.number(),
  outfitterId: z.number(),
  assetFamilyId: z.string(),
  type: OutfitterInventoryTypeEnum,
  date: isoZ.date().nullable(),
  quantity: z.number().refine((val) => val !== 0, { message: 'Quantity cannot be zero' }),
  notes: z.string().max(512).nullable(),
  workOrderId: z.string().nullable(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type outfitterInventoryModel = z.infer<typeof outfitterInventoryModel>

export const intentoryTypeLabels = OutfitterInventoryTypeEnum.enumLabels
